import { Link as MuiLink } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

const LinkRouter = (props: any) => {
  return <MuiLink {...props} component={RouterLink} />;
};

export default LinkRouter;
